import { useEffect } from 'react';

const APPLE = /Mac|iPhone|iPad/;

export function isApplePlatform(): boolean {
  return APPLE.test(navigator.userAgent);
}

/** ⌘/Ctrl + `key`, capturado antes de qualquer campo. Desligado (`enabled: false`), a tecla segue para o navegador. */
export function useCommandHotkey(onOpen: () => void, key = 'k', enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const handler = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() !== key) return;
      if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey) return;
      event.preventDefault();
      onOpen();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [onOpen, key, enabled]);
}

export function shortcutLabel(key: string): string {
  // eslint-disable-next-line lingui/no-unlocalized-strings -- nome de tecla, igual em qualquer idioma
  const modifier = isApplePlatform() ? '⌘' : 'Ctrl+';
  return `${modifier}${key.toUpperCase()}`;
}
